import type { Dict } from "../core.js";
import type { planMapping as vi } from "../vi/planMapping.js";

export const planMapping: Dict<typeof vi> = {
  title: "Plan mapping",
  subtitleBefore: "Map each source's native plans onto the shared five-tier axis. Unmapped plans do",
  subtitleStrong: "not",
  subtitleAfter: "fall into « free » — they sit separately under « unmapped ».",
  loadFailed: "Couldn't load the plan list.",
  saveFailed: "Couldn't save the mapping.",
  mapped:
    "Mapped « {name} » to tier {tier}. Past periods stay unchanged — the new mapping applies from the next scan.",
  unmappedBanner: "plans not yet mapped to the shared axis. Their customers don't show up in the right place in the tier table.",
  emptyApp: "This app hasn't declared any plans yet.",
  emptyAll: "No plans declared yet.",
  emptyHint:
    "The worker records the plan list on every scan — sources without a notion of plans have no rows here, and that's expected.",
  "col.source": "Source",
  "col.nativePlan": "Source plan",
  "col.customers": "Customers",
  "col.interval": "Billing cycle",
  "col.price": "Price",
  "col.tier": "Shared tier",
  "col.mappedBy": "Mapped by",
  unmapped: "Unmapped",
  footnote:
    "Price and billing cycle come from the source itself. Blank means the source defines its price list in code rather than in the database — the hub doesn't guess, so it doesn't compute recurring revenue for that source.",
  everyMonth: "monthly",
  everyYear: "yearly",
  everyNMonths: "every {count} months",
  everyNYears: "every {count} years",
};
